import { IncidentListResponse } from "entities/incidents";
import { GET } from "utils/http";

const baseUrl = "/api/incidents";

const noRedirect = { skipAuthRedirect: true };

export const getList = (query: string) =>
  GET<IncidentListResponse>(`${baseUrl}${query}`, noRedirect);
